import React from 'react';

import { USER_TIMEZONE_SELECT_OPTIONS } from '../../utils';
import { EnumSelect } from '../EnumSelect';

interface IUserTimezoneSelectProps {
  value: string | null | undefined;
  onChange: (value: string) => any;
  contextualTimezone?: {
    value: string | null | undefined;
    formatLabel: (label: string) => React.ReactNode;
  };
  style?: React.CSSProperties;
}

// Uses modified list of user timezone select options
// (adds user's timezone if it's not already included in the enum options)
export const UserTimezoneSelect = (props: IUserTimezoneSelectProps) => {
  const { value, onChange, contextualTimezone, style } = props;

  return (
    <EnumSelect
      enumTable='Timezone'
      value={value}
      onChange={v => onChange(v)}
      formatOptions={() => {
        // Optionally flag contextual timezone (e.g., property timezone)
        if (contextualTimezone) {
          return USER_TIMEZONE_SELECT_OPTIONS.map((option) => {
            const label = option.value === contextualTimezone.value
              ? contextualTimezone.formatLabel(option.label)
              : option.label;

            return { label, value: option.value };
          });
        }

        return USER_TIMEZONE_SELECT_OPTIONS;
      }}
      style={style}
    />
  );
};
